// Highlighting for code outside a file view (suggested changes, the
// suggestion editor): the engine's spans for a few lines of a file, which
// render with the diff's `syn-<class>` CSS.
import type { Span } from '../engine/types';
import { eng, engineDegraded } from './engine';

const languages = new Map<string, Promise<string | null>>();

/** The engine's language ID for a path, or null (plain text). */
export function languageOf(path: string): Promise<string | null> {
  let p = languages.get(path);
  if (!p) {
    p = eng.detectLanguage(path).catch(() => null);
    languages.set(path, p);
  }
  return p;
}

/**
 * Highlight spans for `text`, one entry per line; null for plain text: no
 * language, the engine degraded to its fallback, or the call failed. The
 * snippet is parsed on its own, without the rest of its file.
 */
export async function highlightText(language: string | null, text: string): Promise<Span[][] | null> {
  if (!language || engineDegraded()) return null;
  try {
    return (await eng.highlight(language, text)).lines;
  } catch {
    return null;
  }
}
